export default "__VITE_ASSET__a986cf9b__"